import { BaseApiError, ApiClient, getApiBaseUrl } from '../shared';

export interface MfaSendResponse {
  status: string;
  device_id?: string;
  pre_auth_session_id?: string;
  expires_in?: number;
  resend_available_in?: number;
}

export interface MfaVerifyResponse {
  status: string;
}

export class MfaApiError extends BaseApiError {
  constructor(message: string, status?: number, fieldErrors?: Record<string, string>, code?: string) {
    super(message, status, fieldErrors, code);
    this.name = 'MfaApiError';
  }
}

const apiClient = new ApiClient<MfaApiError>(
  (message, status, _fields, code) => new MfaApiError(message, status, undefined, code),
  { baseUrl: `${getApiBaseUrl()}/auth` }
);

export const mfaService = {
  async sendOtp(email?: string): Promise<MfaSendResponse> {
    return apiClient.post<MfaSendResponse>('/mfa/otp/send', email ? { email } : {});
  },
  async verifyOtp(code: string): Promise<MfaVerifyResponse> {
    return apiClient.post<MfaVerifyResponse>('/mfa/otp/verify', { code });
  },
};

